import { getUserID } from './userId';

const API_BASE = 'https://a.tryrino.com';

let _projectKey = null;
let _eventContext = {};
let _platform = null;

function detectPlatform() {
    if (_platform) return _platform;
    try {
        const ua = navigator.userAgent || '';
        const isIOS =
            /iPad|iPhone|iPod/.test(ua) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        const isAndroid = /Android/.test(ua);
        if (isIOS) _platform = 'ios';
        else if (isAndroid) _platform = 'android';
        else _platform = 'desktop';
    } catch (e) {
        _platform = 'unknown';
    }
    return _platform;
}

function post(path, payload) {
    return fetch(`${API_BASE}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
    });
}

export function initRinoAnalytics(projectKey) {
    _projectKey = projectKey;
    getUserID();

    const queryIdentities = {};
    const params = new URLSearchParams(window.location.search);
    for (const [key, value] of params.entries()) {
        queryIdentities[`query_${key}`] = value;
    }
    if (Object.keys(queryIdentities).length > 0) {
        rinoSetIdentity(queryIdentities);
    }
}

export function setRinoEventContext(context) {
    _eventContext = { ...(context || {}) };
}

export function rinoLogEvent(eventName, properties) {
    try {
        if (!_projectKey) return;
        const merged = { ..._eventContext, ...(properties || {}), platform: detectPlatform() };
        console.log(`Rino: ${eventName}`, merged);
        post('/analytics/logEvent', {
            projectKey: _projectKey,
            userID: getUserID(),
            eventName,
            eventTime: Date.now(),
            properties: merged,
        }).catch(err => console.error('rinoLogEvent error:', err));
    } catch (err) {
        console.error('rinoLogEvent error:', err);
    }
}

export function rinoSetIdentity(identities) {
    try {
        if (!_projectKey) return;
        console.log('Rino identity:', identities);
        post('/analytics/setIdentity', {
            projectKey: _projectKey,
            userID: getUserID(),
            identities: identities || {},
        }).catch(err => console.error('rinoSetIdentity error:', err));
    } catch (err) {
        console.error('rinoSetIdentity error:', err);
    }
}
